import Grid from '@mui/material/GridLegacy';
import { styled } from '@mui/material/styles';
import React from 'react';
import { colors } from '../../theme/default/color';
import { ContactForm } from '../ContactForm';
import { GradientText } from '../GradientText';
import type { LetsCollaborateProps } from './LetsCollaborate.types';
import { Box } from '@mui/material';

const StyledLetsCollaborate = styled(Box)(({ theme }) => ({
  background: colors.white,
  padding: theme.spacing(16, 0),
}));

export const LetsCollaborate: React.FC<LetsCollaborateProps> = ({
  github = false,
  linkedin = false,
  subject,
  submitButtonText,
  scrollRef,
  ...props
}) => {
  return (
    <StyledLetsCollaborate {...props}>
      <Grid item xs={12} container justifyContent="center">
        <Grid item xs={10} sm={8} container justifyContent="center">
          <Grid item xs={12} md={6} ref={scrollRef}>
            <GradientText type="huge">
              let's
              <br />
              collab
              <br />
              orate
            </GradientText>
          </Grid>
          <Grid item xs={12} md={6}>
            <ContactForm
              subject={subject}
              submitButtonText={submitButtonText}
              github={github}
              linkedin={linkedin}
            />
          </Grid>
        </Grid>
      </Grid>
    </StyledLetsCollaborate>
  );
};
